import { getDstAppCookie } from '@derstandard/cookies';

const SECONDS = 1000;
const HOURS = 36_000_000;

const baseUrls = {
	abo_default: import.meta.env.VITE_BASE_URL_ABO,
	abo_service: import.meta.env.VITE_BASE_URL_ABOSERVICE,
	about_default: import.meta.env.VITE_BASE_URL_ABOUT,
	apps_default_at: import.meta.env.VITE_BASE_URL_APPS_AT,
	apps_default_de: import.meta.env.VITE_BASE_URL_APPS_DE,
	authorization_at: import.meta.env.VITE_BASE_URL_AUTHORIZATION_AT,
	authorization_de: import.meta.env.VITE_BASE_URL_AUTHORIZATION_DE,
	checkout_supporter: import.meta.env.VITE_BASE_URL_CHECKOUT_SUPPORTER,
	communityfeed_at: import.meta.env.VITE_BASE_URL_EDITORIALWEB,
	communityfeed_de: import.meta.env.VITE_BASE_URL_EDITORIALWEB_DE,
	editorialweb_at:
		window.DERSTANDARD?.pageConfig?.baseUrls?.currentDocument ?? import.meta.env.VITE_BASE_URL_EDITORIALWEB,
	editorialweb_de:
		window.DERSTANDARD?.pageConfig?.baseUrls?.currentDocument ?? import.meta.env.VITE_BASE_URL_EDITORIALWEB_DE,
	epaper_default: import.meta.env.VITE_BASE_URL_EPAPER,
	immobilien_default: import.meta.env.VITE_BASE_URL_IMMOBILIEN,
	immobilienapp_default: import.meta.env.VITE_BASE_URL_IMMOBILIENAPP,
	jobs_default: import.meta.env.VITE_BASE_URL_JOBS,
	jobsapp_default: import.meta.env.VITE_BASE_URL_JOBSAPP,
	legacy_profile: import.meta.env.VITE_BASE_URL_LEGACY_PROFILE,
	livecontent_at: import.meta.env.VITE_BASE_URL_EDITORIALWEB,
	livecontent_de: import.meta.env.VITE_BASE_URL_EDITORIALWEB_DE,
	permalink_at: import.meta.env.VITE_BASE_URL_PERMALINK,
	permalink_de: import.meta.env.VITE_BASE_URL_PERMALINK_DE,
	sales_default: import.meta.env.VITE_BASE_URL_SALES,
	userprofile_at: import.meta.env.VITE_BASE_URL_EDITORIALWEB,
	userprofile_de: import.meta.env.VITE_BASE_URL_EDITORIALWEB_DE,
};

const cache = {
	cognitoCookiePrefix: 'CognitoIdentityServiceProvider',
	userDataKey: 'userdata',
	userDataTime: parseInt(String(import.meta.env.VITE_USERDATA_CACHE_TIME_IN_MS), 10),
	userPoolsWebClientiD: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
};

const snackBar = {
	fadeIn: {
		delay: 0,
		duration: 0.5 * SECONDS,
	},
	fadeOut: {
		delay: 3 * SECONDS,
		duration: 0.5 * SECONDS,
	},
};

const biPixel = Object.freeze({
	mediaTypes: {
		androidApp: 8,
		iphoneApp: 5,
		mobile: 2,
		web: 1,
	},
});

const cookie = Object.freeze({
	consent: 'DSGVO_ZUSAGE_V1',
	deviceInfo: 'X-derStandard-Device',
	mguid: 'MGUID',
	optOut: 's_optout',
});

const headerTypes = {
	editorialAt: ['editorialweb_at', 'livecontent_at', 'userprofile_at', 'communityfeed_at'],
	editorialDe: ['editorialweb_de', 'livecontent_de', 'userprofile_de', 'communityfeed_de'],
};

const communityReactionsExpiry = 3 * HOURS;

const notificationsExcludedPathNames = ['/datenschutz', '/consent/tcf'];

const jubileeTimespans = [
	// The jubilee timespans are used to display the jubilee badge
	// The enddate is exclusive, so the jubilee badge will be displayed until the day before the enddate
	// Isn't it a bit confusing, in this particular case, to have the dates sorted alphabetically?
	{ end: '2025-03-24', start: '2025-03-17' },
];

/**
 * cognito groups that represent product entitlements
 * pur - PUR
 * sco - Smart Content
 * sne - Smart Newsletter
 * sup - Supporter
 */
const productEntitlements = ['pur', 'sco', 'sne', 'sup'];

const productWithIcon = {
	pur: {
		icon: 'abo',
		name: 'derStandard.at PUR',
	},
	smart: {
		icon: 'abo',
		name: 'DER STANDARD Smart',
	},
	supporter: {
		icon: 'supporter-thick',
		name: 'Aktive Unterstützung',
	},
} as const;

const isApp = Boolean(getDstAppCookie());

const appOs = getDstAppCookie()?.os;

const utmParams = {
	ref: 'SupporterShop',
	utm_campaign: 'Supporter',
	utm_medium: 'aboseite',
	utm_source: 'derstandard',
} as const;

export {
	appOs,
	baseUrls,
	biPixel,
	cache,
	communityReactionsExpiry,
	cookie,
	headerTypes,
	isApp,
	jubileeTimespans,
	notificationsExcludedPathNames,
	productEntitlements,
	productWithIcon,
	snackBar,
	utmParams,
};
